import * as React from 'react';
import { MdAdd } from 'react-icons/md';
import { SimpleFormProps, SimpleFormComponentProps } from 'app/infrastructure/simple-form/types';
import { SimpleFormValidationConfig, requiredValidation } from 'app/infrastructure/simple-form';
import { ConsentType, Subscription, Consent, NotificationPermissionType, CheckConsent } from 'app/area/user-profile/my-notifications/types';
import { PushModal } from 'app/area/user-profile/my-notifications/consents/push-modal';
import { form, MyNotificationTranslation } from 'app/area/user-profile/my-notifications/constants';
import { ValidationProps, AddButton } from 'ui';
import { defaultSerializeMappings } from 'app/infrastructure/simple-form/serialize';

import styles from './add-sms-consent.scss';
import { getNotificationPermission } from 'app/area/user-profile/my-notifications/notification-permission';
import { Messaging } from 'app/infrastructure/push/types';

interface AddConsentExternalProps {
  id?: number;
  recipientId: number;
  value: Messaging;
  fetchingSaveSubscription: boolean;
  sharedState?: any;
  validation: ValidationProps[];
  translation?: MyNotificationTranslation;
  formComponent: React.ComponentType<SimpleFormComponentProps>;
  consents: Consent[];
  loadConsents: () => void;
  saveSubscription: (id: number, subscription: Subscription, onSuccess: () => void) => void;
  clearValidation: (fieldName: string) => void;
  checkConsent: (payload: CheckConsent) => void;
}

interface AddPushConsentState {
  isOpen: boolean;
}

export type AddPushConsentProps = AddConsentExternalProps & SimpleFormProps;

export class AddPushConsent extends React.PureComponent<AddPushConsentProps, AddPushConsentState> {
  public state: Readonly<AddPushConsentState> = {
    isOpen: false
  };

  private handleToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  private addConsent = (token: string) => {
    const {
      saveSubscription,
      sharedState: { id: recipientId },
      serialize,
      validate,
      translation,
      loadConsents
    } = this.props;

    const serializedForm = serialize(defaultSerializeMappings);

    const subscription = {
      recipientId,
      type: ConsentType.push,
      value: {
        name: String(serializedForm.name),
        token
      }
    };

    const validationConfig: SimpleFormValidationConfig = [
      requiredValidation(form.push.name)
    ];

    validate(validationConfig, () =>
      saveSubscription(undefined, subscription,
        () => {
          this.handleToggle();
          loadConsents();
        }), translation.validation_error);
  };

  private isDisabled = (): boolean => {
    const permission = getNotificationPermission();
    return permission !== NotificationPermissionType.Granted;
  };

  private onDone = () => {
    const { checkConsent, consents, value, translation, id } = this.props;
    return checkConsent({ consents, onDone: this.addConsent, translation, value, id });
  };

  public render() {
    const { fetchingSaveSubscription, translation, value } = this.props;

    return <div className={styles.wrapper}>
      <div className={styles.wrapper}>
        <AddButton
          icon={MdAdd}
          onClick={this.handleToggle}
          disabled={this.isDisabled()}>
          {translation.add_push_title}
        </AddButton>
      </div>

      {this.state.isOpen
        && <PushModal
          fetching={fetchingSaveSubscription}
          onDone={this.onDone}
          value={value}
          onClose={this.handleToggle}
          {...this.props} />}
    </div>;
  }
}
